import { Datatype } from '@framework/engine/schema/expressions/datatype/Datatype.ts';
import { createSubjectDataType } from './SubjectDataTypes.ts';

const CompanyApplicantDataTypesAll = {
  companyName: createSubjectDataType('companyName', {
    label: 'Azienda: Denominazione',
    type: Datatype.String,
  }),
  companyVatNumber: createSubjectDataType('companyVatNumber', {
    label: 'Azienda: Partita IVA',
    type: Datatype.String,
  }),
  companyFiscalNumber: createSubjectDataType('companyFiscalNumber', {
    label: 'Azienda: Codice Fiscale',
    type: Datatype.String,
  }),
  companyLegalForm: createSubjectDataType('companyLegalForm', {
    label: 'Azienda: Forma giuridica',
    type: Datatype.String,
  }),
  companyCountry: createSubjectDataType('companyCountry', {
    label: 'Azienda: Paese',
    type: Datatype.String,
  }),
  companyAddress: createSubjectDataType('companyAddress', {
    label: 'Azienda: Indirizzo',
    type: Datatype.String,
  }),
  companyMunicipality: createSubjectDataType('companyMunicipality', {
    label: 'Azienda: Comune',
    type: Datatype.String,
  }),
  companyPostalCode: createSubjectDataType('companyPostalCode', {
    label: 'Azienda: CAP',
    type: Datatype.String,
  }),
  companyProvince: createSubjectDataType('companyProvince', {
    label: 'Azienda: Provincia',
    type: Datatype.String,
  }),
  companyEmail: createSubjectDataType('companyEmail', {
    label: 'Azienda: Indirizzo e-mail',
    type: Datatype.String,
  }),
  companyPec: createSubjectDataType('companyPec', {
    label: 'Azienda: PEC',
    type: Datatype.String,
  }),
  companyRea: createSubjectDataType('companyRea', {
    label: 'Azienda: Codice REA',
    type: Datatype.String,
  }),
  companyAteco: createSubjectDataType('companyAteco', {
    label: 'Azienda: Codice ATECO',
    type: Datatype.String,
  }),
};

type CompanyApplicantDataTypesSchema = typeof CompanyApplicantDataTypesAll;
export type CompanyApplicantDataKey = keyof CompanyApplicantDataTypesSchema;

export type ICompanyApplicantData = {
  [K in keyof CompanyApplicantDataTypesSchema]: string | undefined;
};

export class CompanyApplicantDataTypes {
  static Map = CompanyApplicantDataTypesAll;

  static List = Object.values(CompanyApplicantDataTypesAll);

  static Codes = Object.keys(CompanyApplicantDataTypesAll) as Array<
    keyof typeof CompanyApplicantDataTypesAll
  >;

  /**
   * Ritorna true se la chiave passata è una chiave di dati aziendali.
   * (e.g. companyName, companyFiscalNumber, ...)
   */
  static isCompanyDataCode(
    key: string | undefined,
  ): key is CompanyApplicantDataKey {
    if (!key) return false;
    return CompanyApplicantDataTypes.Codes.includes(
      key as CompanyApplicantDataKey,
    );
  }
}
